// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* MenuModal.css */
html, body {
    height: 100%;
    margin: 0;
    padding: 0;
    overflow-y: auto; /* Allow scrolling when modal is not open */
}

.menu-modal-overlay {
    position: fixed;
    inset: 0;  /* Cover the entire screen */
    padding: env(safe-area-inset-top) env(safe-area-inset-right) 
             env(safe-area-inset-bottom) env(safe-area-inset-left);
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    opacity: 0;
    overflow: hidden;
    transition: opacity 0.3s ease; /* Smooth transition */
}

.menu-modal {
    display: flex;
    background-color: white;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    width: 300px;
}

.menu-links{
    width: 100%;
}

.close-button {
    position: absolute;
    color: rgb(207, 207, 207);
    top: 0px;
    right: 0px;
    padding: 20px;
    background: none;
    border: none;
    font-size: 35px;
    font-weight: 100;
    cursor: pointer;
}

.menu-links {
    list-style-type: none;
    padding: 0;
    font-size: 20px;
}

.page-link {
    margin: 30px 0;
}

.fade-in {
    opacity: 1;
}

.fade-out {
    opacity: 0;
    pointer-events: none; /* Prevent clicks during fade-out */
}`, "",{"version":3,"sources":["webpack://./src/MenuModal.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;IACI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,gBAAgB,EAAE,2CAA2C;AACjE;;AAEA;IACI,eAAe;IACf,QAAQ,GAAG,4BAA4B;IACvC;kEAC8D;IAC9D,uBAAuB;IACvB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,6BAA6B,EAAE,sBAAsB;AACzD;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,QAAQ;IACR,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,oBAAoB,EAAE,mCAAmC;AAC7D","sourcesContent":["/* MenuModal.css */\nhtml, body {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n    overflow-y: auto; /* Allow scrolling when modal is not open */\n}\n\n.menu-modal-overlay {\n    position: fixed;\n    inset: 0;  /* Cover the entire screen */\n    padding: env(safe-area-inset-top) env(safe-area-inset-right) \n             env(safe-area-inset-bottom) env(safe-area-inset-left);\n    background-color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n    opacity: 0;\n    overflow: hidden;\n    transition: opacity 0.3s ease; /* Smooth transition */\n}\n\n.menu-modal {\n    display: flex;\n    background-color: white;\n    width: 100%;\n    height: 100%;\n    align-items: center;\n    justify-content: center;\n    width: 300px;\n}\n\n.menu-links{\n    width: 100%;\n}\n\n.close-button {\n    position: absolute;\n    color: rgb(207, 207, 207);\n    top: 0px;\n    right: 0px;\n    padding: 20px;\n    background: none;\n    border: none;\n    font-size: 35px;\n    font-weight: 100;\n    cursor: pointer;\n}\n\n.menu-links {\n    list-style-type: none;\n    padding: 0;\n    font-size: 20px;\n}\n\n.page-link {\n    margin: 30px 0;\n}\n\n.fade-in {\n    opacity: 1;\n}\n\n.fade-out {\n    opacity: 0;\n    pointer-events: none; /* Prevent clicks during fade-out */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
